import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import useAuthStore from "@/store/use-auth-store";

/**
 * Upload Image Hook
 * Handles image upload to R2 server with validation
 */
export const useUploadImage = () => {
  const queryClient = useQueryClient();
  const { setUser } = useAuthStore();

  return useMutation({
    mutationFn: (file: File) => queryService.uploadImage(file),

    onSuccess: (response) => {
      if (response.data) {
        // Update user image in auth store
        const currentUser = useAuthStore.getState().user;
        if (currentUser) {
          setUser({
            ...currentUser,
            image: response.data, // R2 file object
          });
        }
      }

      // Invalidate user queries to refresh data
      queryClient.invalidateQueries({
        queryKey: ["user"],
      });

      console.log("✅ Image uploaded and user updated successfully");
    },

    onError: (error) => {
      console.error("❌ Failed to upload image:", error);
    },
  });
};
